import { render, staticRenderFns } from "./CommentReply.vue?vue&type=template&id=189aacac&scoped=true&"
import script from "./CommentReply.vue?vue&type=script&lang=js&"
export * from "./CommentReply.vue?vue&type=script&lang=js&"
import style0 from "./CommentReply.vue?vue&type=style&index=0&id=189aacac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aacac",
  null
  
)

export default component.exports